import { create } from 'zustand';
import { readJSON, writeJSON } from '../lib/storage';

const KEY = 'sw.settings.v1';

export type Quality = 'auto' | 'low' | 'medium' | 'high';
export type RenderMode = 'auto' | '3d' | '2d';

export interface Settings {
  master: number;
  music: number;
  sfx: number;
  muted: boolean;
  quality: Quality;
  render: RenderMode;
  reducedMotion: boolean;
}

const DEFAULTS: Settings = {
  master: 0.8,
  music: 0.45,
  sfx: 0.8,
  muted: false,
  quality: 'auto',
  render: 'auto',
  reducedMotion: false,
};

interface SettingsState extends Settings {
  update(patch: Partial<Settings>): void;
}

export const useSettings = create<SettingsState>((set, get) => ({
  ...DEFAULTS,
  ...(readJSON<Partial<Settings>>(KEY) ?? {}),
  update(patch) {
    set(patch);
    const { update: _u, ...rest } = get();
    writeJSON(KEY, rest);
  },
}));
